import { render, staticRenderFns } from "./AddBase.vue?vue&type=template&id=1f4d55a2&scoped=true&"
import script from "./AddBase.vue?vue&type=script&lang=ts&"
export * from "./AddBase.vue?vue&type=script&lang=ts&"
import style0 from "./AddBase.vue?vue&type=style&index=0&id=1f4d55a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4d55a2",
  null
  
)

export default component.exports